<template>
  <div class="content create_report_step if-profile edit_myData px-4">
    <PulseLoader :loading="!loaded" :class="{ hide: loaded }" quote="Action is the foundational key to all success" author="Pablo Picasso" profession="Spanish Painter" img="picasso.jpg"></PulseLoader>
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <nav aria-label="breadcrumb" role="navigation" class="m-0">
          <ol class="breadcrumb md-layout">
            <li class="breadcrumb-item">
              <router-link :to="{ name: defaultScreen }"> Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'MyData' }">
                My Data
              </router-link>
            </li>
            <li class="breadcrumb-item active  md-layout-item md-medium-size-70 md-xsmall-size-70 md-size-70">
              Edit
            </li>
            <div class="md-layout-item md-medium-size-10 md-xsmall-size-10 md-size-10">
              <md-button class="md-raised md-info md-round m-0">
                <a :href="pathToDownload" @click.prevent="downloadFile(pathToDownload)" class="href-white"> Download CSV Template </a>
              </md-button>
            </div>
          </ol>
        </nav>
      </div>
    </div>
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 mt-4 mb-4">
        <div class="md-layout">
          <md-button @click="goBack()" class="go-back-btn">
            <md-icon>keyboard_double_arrow_left</md-icon>
            Back
          </md-button>
          <h1 class="section_header m-0">Edit My Data</h1>
          <div class="md-toolbar-section-end" v-if="loaded">
            <div class="links client-button-box" style="max-width:nullpx;">
              <md-button class="md-raised md-info md-round m-0" @click="yearModal = true">
                <md-icon class="ml-5">add_to_queue</md-icon>
                Add Year
              </md-button>
            </div>
          </div>
        </div>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 edit_data">
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" v-if="!years">
            No data currently
          </div>
          <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
            <nav-tabs-card>
              <md-tabs md-alignment="left">
                <md-tab v-for="(year, key) in years" :key="key" :id="key" :md-label="year.year" md-icon="arrow_drop_down" class="p-0">
                  <div class="md-layout">
                    <div class="md-layout-item p-0">
                      <md-card-header>
                        {{ year.year }}
                      </md-card-header>
                      <md-card-content>
                        <div class="card-description">
                          <div class="row">
                            <div class="px-4">
                              <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 mr-auto" slot="content-right">
                                <h3 class="color-blue">
                                  <strong>Income Statement</strong>
                                </h3>
                                <div class="field-wrap">
                                  <md-field>
                                    <label>Business Revenue*</label>
                                    <md-input v-model="year.businessRevenue" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Cost of Sales - Labor Portion</label>
                                    <md-input v-model="year.costOfSalesLaborPortion" type="number"></md-input>
                                  </md-field>
                                  <md-field>
                                    <label>Gross Margin*</label>
                                    <md-input v-model="year.grossMargin" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Officers Compensation</label>
                                    <md-input v-model="year.officersComp" type="text"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'simple'">
                                    <label>Pre-tax Net Profit</label>
                                    <md-input v-model="year.preTaxNetProfit" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'simple'">
                                    <label>Depreciation-Other Non-Cash Expenses</label>
                                    <md-input v-model="
                                      year.depreciationOtherNonCashExpenses
                                    " type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'simple'">
                                    <label>Operating Expenses</label>
                                    <md-input v-model="year.operatingExpenses" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'simple'">
                                    <label>Interest Expense</label>
                                    <md-input v-model="year.interestExpense" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Salary-Wages</label>
                                    <md-input v-model="year.salaryWages" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Rent</label>
                                    <md-input v-model="year.rent" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Taxes Paid</label>
                                    <md-input v-model="year.taxesPaid" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Advertising</label>
                                    <md-input v-model="year.advertising" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Benefits-Pensions</label>
                                    <md-input v-model="year.benefitsPension" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Repairs</label>
                                    <md-input v-model="year.repairs" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Bad Debt</label>
                                    <md-input v-model="year.badDebt" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Sales, General, Admin & Misc.</label>
                                    <md-input v-model="year.salesGeneralAdminMisc" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Amortization Depreciation Depletion</label>
                                    <md-input v-model="
                                      year.amortizationDepreciationDepletion
                                    " type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Interest Income</label>
                                    <md-input v-model="year.interestIncome" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Interest Expense</label>
                                    <md-input v-model="year.interestExpense" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Other Income</label>
                                    <md-input v-model="year.otherIncome" type="number"></md-input>
                                  </md-field>
                                  <md-field v-if="myData.type === 'advanced'">
                                    <label>Income Tax</label>
                                    <md-input v-model="year.incomeTax" type="number"></md-input>
                                  </md-field>
                                </div>
                                <!-- <div class="input-section-label">
                                      Balance Sheet
                                    </div> -->
                                <h3 class="color-blue">
                                  <strong>Balance Sheet</strong>
                                </h3>
                                <div class="field-wrap" v-if="myData.type === 'simple'">
                                  <md-field>
                                    <label>Accounts Receivable</label>
                                    <md-input v-model="year.accountsReceivable" type="number"></md-input>
                                  </md-field>
                                  <md-field>
                                    <label>Total Current Assets</label>
                                    <md-input v-model="year.totalCurrentAssets" type="number"></md-input>
                                  </md-field>
                                  <md-field>
                                    <label>Total Assets</label>
                                    <md-input v-model="year.totalAssets" type="number"></md-input>
                                  </md-field>
                                  <md-field>
                                    <label>Accounts Payable</label>
                                    <md-input v-model="year.accountsPayable" type="number"></md-input>
                                  </md-field>
                                  <md-field>
                                    <label>Total Current Liabilities</label>
                                    <md-input v-model="year.totalCurrentLiabilities" type="number"></md-input>
                                  </md-field>
                                  <md-field>
                                    <label>Long Term Liabilities</label>
                                    <md-input v-model="year.longTermLiabilities" type="number"></md-input>
                                  </md-field>
                                </div>
                                <div class="field-wrap" v-if="myData.type === 'advanced'">
                                  <md-field>
                                    <label>Cash</label>
                                    <md-input v-model="year.cash" type="number"></md-input>
                                  </md-field>
                                  <md-field>
                                    <label>Receivables</label>
                                    <md-input v-model="year.receivables" type="number"></md-input>
                                  </md-field>
                                  <md-field>
                                    <label>Inventory</label>
                                    <md-input v-model="year.inventory" type="number"></md-input>
                                  </md-field>
                                  <md-field>
                                    <label>Other Current Assets</label>
                                    <md-input v-model="year.otherCurrentAssets" type="number"></md-input>
                                  </md-field>
                                  <md-field>
                                    <label>Gross Fixed Assets</label>
                                    <md-input v-model="year.grossFixedAssets" type="number"></md-input>
                                  </md-field>
                                  <md-field>
                                    <label>Accum. Depreciation-Amortization-Depltn.</label>
                                    <md-input v-model="
                                      year.accumDepreciationAmortizationDepltn
                                    " type="number"></md-input>
                                  </md-field>
                                  <md-field>
                                    <label>Net Fixed Assets</label>
                                    <md-input v-model="year.netFixedAssets" type="number"></md-input>
                                  </md-field>
                                  <md-field>
                                    <label>Other Non-Current Assets</label>
                                    <md-input v-model="year.otherNonCurrentAssets" type="number"></md-input>
                                  </md-field>
                                </div>
                                <div v-if="myData.type === 'simple'">
                                  <!-- <div class="input-section-label">
                                        Employment Data
                                      </div> -->
                                  <h3 class="color-blue">
                                    <strong>Employment Data</strong>
                                  </h3>
                                  <div class="field-wrap">
                                    <md-field>
                                      <label>Employment</label>
                                      <md-input v-model="year.employment" type="number"></md-input>
                                    </md-field>
                                    <md-field>
                                      <label>Average Annual Wage</label>
                                      <md-input v-model="year.averageAnnualWage" type="number"></md-input>
                                    </md-field>
                                  </div>
                                </div>
                                <div v-if="myData.type === 'advanced'">
                                  <!-- <div class="input-section-label">
                                        Liabilities
                                      </div> -->
                                  <h3 class="color-blue">
                                    <strong>Liabilities</strong>
                                  </h3>
                                  <div class="field-wrap">
                                    <md-field>
                                      <label>Accounts Payable</label>
                                      <md-input v-model="year.accountsPayable" type="number"></md-input>
                                    </md-field>
                                    <md-field>
                                      <label>Loans/Notes Payable</label>
                                      <md-input v-model="year.loansNotesPayable" type="number"></md-input>
                                    </md-field>
                                    <md-field>
                                      <label>Other Current Liabilities</label>
                                      <md-input v-model="year.otherCurrentLiabilities" type="number"></md-input>
                                    </md-field>
                                    <md-field>
                                      <label>Total Long Term Liabilities</label>
                                      <md-input v-model="year.totalLongTermLiabilities" type="number"></md-input>
                                    </md-field>
                                  </div>
                                </div>
                                <div v-if="myData.type === 'advanced'">
                                  <!-- <div class="input-section-label">
                                        Other
                                      </div> -->
                                  <h3 class="color-blue">
                                    <strong>Other</strong>
                                  </h3>
                                  <div class="field-wrap">
                                    <md-field>
                                      <label>FTE Employees</label>
                                      <md-input v-model="year.employment" type="number"></md-input>
                                    </md-field>
                                    <md-field>
                                      <label>Avg. Annual Wage</label>
                                      <md-input v-model="year.averageAnnualWage" type="number"></md-input>
                                    </md-field>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </md-card-content>
                      <div class="action_wpr">
                        <md-button class="md-danger md-round mr-3 mb-4" @click="postDeleteYear(year.id)">Delete
                        </md-button>
                        <md-button class="md-info md-round mb-4" @click="postUpdateYear(year)">Save</md-button>
                      </div>
                    </div>
                  </div>
                </md-tab>
              </md-tabs>
            </nav-tabs-card>
          </div>
        </div>
      </div>
    </div>
    <modal class="report_inputs" v-if="yearModal" @close="closeYearModal()">
      <template slot="header">
        <h4 class="modal-title">Input Type</h4>
      </template>
      <template slot="body">
        <div class="modal_content">
          <div>
            <h3 class="modal-title">Add Year </h3>
            <div class="field_grp">
              <md-field>
                <label>Year*</label>
                <md-select v-model="inputDataSource.year" name="pages">
                  <md-option v-for="item in yearsInput" :key="item" :label="item" :value="item">
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <h4>Income Statement</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('income_statement')">
                <label>{{ item.label }}</label>
                <md-input v-model="inputDataSource[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <h4 v-if="balanceLabel">Balance Sheet</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('balance_sheet')">
                <label>{{ item.label }}</label>
                <md-input v-model="inputDataSource[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <h4 v-if="employmentLabel">Employment Data</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('employment')">
                <label>{{ item.label }}</label>
                <md-input v-model="inputDataSource[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <h4 v-if="liabilitiesLabel">Liabilities</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('liabilities')">
                <label>{{ item.label }}</label>
                <md-input v-model="inputDataSource[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <h4 v-if="otherLabel">Other</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('other')">
                <label>{{ item.label }}</label>
                <md-input v-model="inputDataSource[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <md-button class="md-info md-round" @click="postCreateYear();">
              <md-icon>add</md-icon>
              Add new Year
            </md-button>
          </div>
        </div>
      </template>
    </modal>
    <modal class="report_inputs" v-if="savedSuccessPopup" @close="savedSuccessPopup = false">
      <template slot="header">
        <h4 class="modal-title">Your inputs have been updated successfully</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="savedSuccessPopup = false">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <div class="modal_content">
          <div>
            <h3 class="modal-title">Your inputs have been updated successfully!</h3>
          </div>
          <div class="padding-lr">
            <md-button @click="savedSuccessPopup = false" class="md-info md-block access-button">
              <span>Ok</span>
            </md-button>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import {Collapse, Modal} from '@/components';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import {PulseLoader} from '@/components'
import CreateReportFormatConstants from '@/helpers/constants/CreateReportFormatConstants.js';
import {mapActions, mapState} from 'vuex';
import axios from 'axios';

export default {
  name: 'edit-my-data',
  components: {
    // Collapse,
    Modal,
    PulseLoader,
  },
  data() {
    return {
      yearsHaveBeenAdded: [],
      yearsInput: ['2019', '2020', '2021', '2022', '2023', '2024'], // TODO: make this automatic.
      myDataYears: [],
      constants: CreateReportFormatConstants,
      savedSuccessPopup: false,
      employmentLabel: false,
      balanceLabel: false,
      incomeStatementLabel: false,
      liabilitiesLabel: false,
      otherLabel: false,
      repFormat: '',
      reportInputs: CreateReportFormatConstants.financialReportInputs,
      loaded: false,
      yearModal: false,
      report: 'financial',
      inputDataSource: {},
      myData: {
        type: 'advanced',
        id: null,
      },
      years: null,
      createData: {},
      yearModalStep: 2,
      imageUrl: '',
      pathToDownload: window.location.origin + '/templates/my-data.csv',
      reportTemplate: null,
      reportTemplateOptions: {
        financial: {
          label: 'Financial',
          value: 'financial',
        },
        market: {
          label: 'Market',
          value: 'market',
        },
        valuation: {
          label: 'Valuation',
          value: 'valuation',
        },
        company: {
          label: 'Company',
          value: 'company',
        },
      }
    };
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
    }),
  },
  watch: {
    yearsHaveBeenAdded() {
      this.yearsInput = this.yearsInput.filter(item => !this.yearsHaveBeenAdded.includes(item));
    }
  },
  methods: {
    ...mapActions({
      registerProductExport: 'tracking/registerProductExport',
    }),
    downloadFile(file) {
      axios.get(file, {responseType: 'blob'})
          .then(response => {
            const blob = new Blob([response.data], {type: 'text/csv'})
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'my-data.csv'
            link.click()
            URL.revokeObjectURL(link.href)
          }).catch()
      this.registerProductExport({
        userId: this.auth_user?.user?.userID,
        productId: this.$route.params.id,
        exportType: 'CSV'
      })
    },
    goBack: function () {
      this.$router.go(-1)
    },
    selectReportType: function (type) {
      this.report = type;
      this.yearModalStep = 2;
    },
    closeYearModal: function () {
      this.yearModal = false;
    },
    openYearModal: function () {
      this.yearModal = true;
      this.yearModalStep = 2;
    },
    getMyData: async function () {
      let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
      );
      let myDataId = this.$route.params.id;
      this.loaded = false;
      let params = {
        session_id: currentSession,
        my_data_id: myDataId,
      };
      await this.$store.dispatch('myData/get', params).then((res) => {
        this.myData = res.data.my_data;
        let year = 2021;
        for (var i = 0; i < res.data.years.length; i++) {
          this.myDataYears.push(year)
          year--;
        }
        this.myDataYears = this.myDataYears.reverse();
        this.years = res.data.years.sort((a, b) => a.year - b.year);
        this.years = this.years.filter(function (el) {
          return el.year != null;
        });
        this.years.forEach(item => {
          this.yearsHaveBeenAdded.push(item.year);
        })
        this.loaded = true;
      });
    },
    chooseInputFormat: async function (type) {
      if (type === 'csv') {
        this.$refs.csvInput.click();
      }
    },
    getDynamicInputs: function () {
      this.yearModalStep = 3;
      this.reportInputs = this.checkReport()
      this.employmentLabel = this.checkLabel('employment');
      this.balanceLabel = this.checkLabel('balance_sheet');
      this.incomeStatementLabel = this.checkLabel('income_statement');
      this.liabilitiesLabel = this.checkLabel('liabilities');
      this.otherLabel = this.checkLabel('other');
    },
    checkLabel: function (label) {
      return Object.entries(this.reportInputs).some(e => e.some(el => el.section === label))
    },
    getInputList: function (type) {
      Object.filter = this.getObjectFilter();
      return Object.filter(this.reportInputs, el => el.section == type)
    },
    getObjectFilter: function () {
      return (obj, predicate) =>
          Object.keys(obj)
              .filter(key => predicate(obj[key]))
              .reduce((res, key) => (res[key] = obj[key], res), {});
    },
    checkReport: function () {
      switch (this.report) {
        case this.constants.reportType.financial.value:
          return this.constants.financialReportInputs;
        case this.constants.reportType.market.value:
          return this.constants.marketReportInputs;
        case this.constants.reportType.company.value:
          return this.constants.companyReportInputs;
        case this.constants.reportType.valuation.value:
          return this.constants.valuationReportInputs;
      }
    },
    fileSelected: async function (event) {
      const files = event.target.files;
      let filename = files[0].name;
      const fileReader = new FileReader();
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      let file = files[0];
      this.uploadCSVFile(file);
    },
    uploadCSVFile: async function (file) {
      let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
      );
      var form = new FormData();
      form.append('csv', file);
      form.append('type', this.myData.type);
      form.append('my_data_id', this.myData.id);
      form.append('session_id', currentSession);
      await this.$store.dispatch('myData/csv', form).then(async (res) => {
        if (res.data.csv_data) {
          this.getMyData();
          this.yearModal = false;
          this.$store.dispatch('alerts/success', 'Inputs added');
        } else {
          this.$store.dispatch('alerts/error', 'Invalid CSV data format.');
        }
      });
    },
    postDeleteYear: async function (yearID) {
      let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
      );
      let params = {
        session_id: currentSession,
        year_id: yearID,
        type: this.myData.type,
      };
      await this.$store.dispatch('year/destroy', params).then((res) => {
        this.$store.dispatch('alerts/success', 'Year deleted.');
        this.getMyData();
      });
    },
    postCreateYear: async function () {
      let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
      );
      let myDataId = this.$route.params.id;
      let type = this.myData.type;
      let createData = this.inputDataSource;
      createData.myDataId = myDataId;
      let params = {
        type: type,
        session_id: currentSession,
        data: createData,
      };
      await this.$store.dispatch('year/add', params).then((res) => {
        this.getMyData();
        this.yearModal = false;
        this.$store.dispatch('alerts/success', 'Year created.');
      });
    },
    postUpdateYear: async function (year) {
      let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
      );
      let myDataId = this.$route.params.id;
      let type = this.myData.type;
      let params = {
        type: type,
        session_id: currentSession,
        my_data_id: myDataId,
        data: year,
      };
      await this.$store.dispatch('year/update', params).then((res) => {
        this.savedSuccessPopup = true;
        //this.$store.dispatch('alerts/success', 'Year updated.');
      });
    },
  },
  async created() {
    await this.getMyData();
  },
};
</script>
<style lang="scss">
.client-name-box {
  display: flex;
  align-items: center;
  margin-top: 5px;

  p {
    width: 90px;
    margin: 0;
  }

  input {
    margin-top: 0;
  }
}

.modal-container {
  max-height: 80vh;
  overflow: scroll;
}

.year-edit-card {
  background: white !important;
}

.go-back-btn {
  background-color: #ffffff !important;
  border-radius: 20px;
  border: 0;
  color: #0cbcf2 !important;
  text-transform: capitalize;
  font-size: 14px;
  font-weight: 600;
  -webkit-box-shadow: none;
  box-shadow: none;
  cursor: pointer;
}
</style>
